import api from "./index";

export default {
  async addToCart(data) {
    return api.post("/giftcards", data);
  },
  redeem(code) {
    return api.post("/account/api/giftcards/redeem", { code });
  },
  async preview(data) {
    return api.post("/giftcards/preview", data);
  },
  async update(id, data) {
    return api.put(`/giftcards/${id}`, data);
  }
};
